<template>
  <div>
    <AddGoal
      :showAddGoal="showAddGoal"
      @close="showAddGoal = false"
      :refresh="refresh"
    ></AddGoal>
    <div class="bg-white m-3 rounded-md">
      <div
        class="border-b-0.5 flex justify-between flex-wrap lg:gap-0 gap-5 items-center p-3 w-full"
      >
        <div class="flex gap-3 w-full">
          <el-tabs type="border-card" v-model="activeTab" class="w-full">
            <el-tab-pane
              v-for="(tab, index) in tabs"
              :key="index"
              :label="tab.name"
              :id="tab.name + index"
              :name="tab.component"
            >
              <div class="flex justify-end m-2">

                <button
                  @click="showAddGoal = true"
                  v-if="activeTab == 'Goals'"
                  class="bg-primary text-white rounded-full px-3 py-3 text-sm"
                >
                  Add
                </button>
              </div>

              <component
                :is="tab.component"
                :key="tab.component"
                v-if="tab.component == activeTab"
              ></component>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProgressCircle } from "vue-progress-circle";

import Goals from "./goals.vue";
import Compentencies from "./compentencies.vue";
import AddGoal from "./addGoal.vue";
import MyReview from "../myreviews/goals.vue";
import ManagerReview from "../managerReview/goals.vue";
import JointReview from "../agreed/goals.vue";
import Recommendation from "../recommendation/recommendationHome.vue";
import Report from "../report/report.vue";
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
// import Loader from "@/components/loader/loader.vue";
export default {
  name: "ObjectivesHome",
  components: {
    ProgressCircle,
    Goals,
    MyReview,
    ManagerReview,
    Compentencies,
    AddGoal,
    JointReview,
    Recommendation,
    Report,
  },
  data() {
    return {
      activeTab: "Goals",
      showAddGoal: false,
      currentScore: 3,
      tabs: [
        { name: "Goal Setting", component: "Goals" },
        { name: "My Review", component: "MyReview" },
        { name: "Manager Review", component: "ManagerReview" },
        { name: "Joint Review", component: "JointReview" },
        { name: "Recommendation", component: "Recommendation" },
        { name: "Report", component: "Report" },
      ],
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      activePeriod: null,
      reviewPeriods: [],
      daysLeftToReviewDeadline: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),

  },
  created() {
    this.getPerformancePeriodSetups();
  },
  methods: {
    errorHandler() {
      return true;
    },
    refresh() {

    },
    getPerformancePeriodSetups() {
      this.loading = true;
      const url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.reviewPeriods = response.data.Data;
            this.activePeriod = this.reviewPeriods.find(
              (period) => period.Active == true
            );

            if (this.activePeriod) {
              // Calculate number of days left to review deadline
              if (this.activePeriod.ReviewDeadline) {
                const reviewDeadline = moment(this.activePeriod.ReviewDeadline);
                const currentDate = moment();
                const daysLeft = reviewDeadline.diff(currentDate, "days");
                this.daysLeftToReviewDeadline = daysLeft >= 0 ? daysLeft : 0;
              }
            }
          } else {
            this.$notify.error({
              title: "Failure",
              message: response.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.$notify.error({ title: "Failure", message: error.message });
        }
      );
    },
  },
};
</script>
